import { render, staticRenderFns } from "./BusinessRadiochannel.vue?vue&type=template&id=30bb3722&"
import script from "./BusinessRadiochannel.vue?vue&type=script&lang=js&"
export * from "./BusinessRadiochannel.vue?vue&type=script&lang=js&"
import style0 from "./BusinessRadiochannel.vue?vue&type=style&index=0&id=30bb3722&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports